export const claimPendingListAction = (payload) => {
  return {
    type: "REQ_CLAIM_PENDING_LIST",
    payload: { data: payload },
  };
};

export const claimPendingListResetAction = (payload) => {
  return {
    type: "RESET_CLAIM_PENDING",
    payload: { data: payload },
  };
};
